"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var constants_1 = require("../constants");
var context_1 = require("../context");
var LoginRoute = function (_a) {
    var children = _a.children;
    var tokens = (0, context_1.useAuth)().tokens;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!tokens.token ? (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: constants_1.DASHBOARD_PATH, replace: true }) : children }));
};
exports.default = LoginRoute;
